import base from "../../../base";

const userIsAdmin = async (uid) => {
	const admins = await base.fetch(`admins`, { context: this });
	if (Object.keys(admins).includes(uid)) return true;
	return false;
};

export default userIsAdmin;
